import { Maximize2 } from "lucide-react";
import { isVideoPath } from "@/lib/api";
import { BeforeAfter } from "../BeforeAfterSlider";

const expandCls =
  "absolute bottom-2 right-2 h-11 w-11 flex items-center justify-center bg-black/60 hover:bg-terracotta text-white rounded-full transition-colors";
const mediaCls = "w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-700 pointer-events-none";

// One Work Gallery item's picture: a before/after slider, a looping clip, or a photo — tap for full screen.
// Shared by the homepage strip (prefix "work-gallery") and the /gallery page (prefix "gallery").
export const WorkMedia = ({ item, prefix, i, onOpen, onBroken }) => {
  const src = `/api/gallery/image/${item.image_path}`;
  if (item.after_path) {
    return (
      <>
        <BeforeAfter testid={`${prefix}-slider-${i}`} cover beforeSrc={src} afterSrc={`/api/gallery/image/${item.after_path}`}
          caption={item.caption} onError={onBroken} onOpen={onOpen} />
        <button type="button" data-testid={`${prefix}-open-${i}`} onClick={onOpen} aria-label="View full screen" className={expandCls}>
          <Maximize2 className="h-5 w-5" />
        </button>
      </>
    );
  }
  if (isVideoPath(item.image_path)) {
    return (
      <>
        <button type="button" data-testid={`${prefix}-open-${i}`} onClick={onOpen} aria-label={item.caption || "Play job video full screen"}
          className="block w-full cursor-pointer">
          <video src={src} poster={item.poster_path ? `/api/gallery/image/${item.poster_path}` : undefined}
            data-testid={`${prefix}-video-${i}`} onError={onBroken} className={mediaCls} autoPlay muted loop playsInline preload="metadata" />
        </button>
        <button type="button" data-testid={`${prefix}-video-expand-${i}`} onClick={onOpen} aria-label="View video full screen" className={expandCls}>
          <Maximize2 className="h-5 w-5" />
        </button>
      </>
    );
  }
  return (
    <button type="button" data-testid={`${prefix}-open-${i}`} onClick={onOpen}
      aria-label={item.caption ? `View full screen: ${item.caption}` : "View photo full screen"} className="block w-full cursor-zoom-in">
      <img src={src} alt={item.caption || "Recent job photo"} loading="lazy" onError={onBroken} className={mediaCls} />
    </button>
  );
};
